import { animate, inView } from 'motion'
import ease from '@/utils/ease'

export default () => ({
	isMarqueeInitialized: false,
	slider: null,
	observer: null,
	reps: 1,

	init() {
		this.setupMarquee()
		this.animateLines()
	},

	setupMarquee() {
		const container = this.$el
		const content = container.querySelector('[data-marquee-content]')
		const item = container.querySelector('[data-marquee-item]')
		const inner = container.querySelector('[data-marquee-inner]')

		// Define speed in pixels per second
		const speedPxPerSecond = 50 // Adjust this value to control speed

		// Setup resize observer for the marquee item
		this.observer = new ResizeObserver((entries) => {
			const containerWidth = container.offsetWidth
			const itemWidth = entries[0].contentRect.width

			// Calculate required repetitions
			this.reps = Math.ceil(containerWidth / itemWidth) + 1

			// First, handle the items within the original content
			const existingItems = content.querySelectorAll('[data-marquee-item]')
			for (let i = existingItems.length - 1; i > 0; i--) {
				content.removeChild(existingItems[i])
			}

			// Create new cloned items in the first content element
			for (let i = 1; i < this.reps; i++) {
				const clone = item.cloneNode(true)
				clone.setAttribute('aria-hidden', 'true')
				content.appendChild(clone)
			}

			// Remove any existing second content clone
			const existingContentClone = inner.querySelector('[data-marquee-content]:nth-child(2)')
			if (existingContentClone) {
				inner.removeChild(existingContentClone)
			}

			// Clone the entire content element
			const contentClone = content.cloneNode(true)
			inner.appendChild(contentClone)

			// Calculate duration based on pixels per second
			const totalWidth = itemWidth * this.reps
			const durationInSeconds = totalWidth / speedPxPerSecond

			content.style.animationDuration = `${durationInSeconds}s`
			contentClone.style.animationDuration = `${durationInSeconds}s`
		})

		// Start observing the first marquee item
		this.observer.observe(item)

		// Cleanup observer when component is destroyed
		this.$cleanup = () => {
			if (this.observer) {
				this.observer.disconnect()
			}
		}
	},

	animateLines() {
		const horizontalLines = this.$el.querySelectorAll('[data-horizontal-line]')
		const verticalLines = this.$el.querySelectorAll('[data-vertical-line]')

		if (horizontalLines?.length) {
			inView(
				this.$el,
				() =>
					animate(
						horizontalLines,
						{ scaleX: 1 },
						{ duration: 0.4, delay: 0.2, easing: ease.inOutQuint },
					),
				{ amount: 0.15 },
			)
		}
		if (verticalLines?.length) {
			inView(
				this.$el,
				() =>
					animate(
						verticalLines,
						{ scaleY: 1 },
						{ duration: 0.4, delay: 0.2, easing: ease.inOutQuint },
					),
				{ amount: 0.15 },
			)
		}
	},
})
